import React from 'react';
import { IMAGES } from '../data/mock';

export default function TheSchool() {
  return (
    <section id="l5" className="chapter" style={{ padding: 0, flexDirection: 'column' }}>
      <div className="scene" style={{ backgroundImage: `url(${IMAGES.goldfish})`, backgroundPosition: 'center' }}>
        <div className="scene-caption">
          <div className="chapter-eyebrow font-sans" style={{ margin: '0 auto 20px', justifyContent: 'center' }}>
            LIFE V &middot; THE SCHOOL
            <span style={{ height: 1, width: 60, background: 'linear-gradient(to right, #f3c04a, transparent)' }} />
          </div>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(28px, 3.5vw, 52px)', color: 'var(--cream)', margin: 0 }}>
            Every legend
          </p>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(28px, 3.5vw, 52px)', color: 'var(--gold)', fontWeight: 600, marginTop: 8 }}>
            <i>swims in a school.</i>
          </p>
          <p style={{ marginTop: 20, color: 'rgba(234,246,245,0.75)', fontSize: 15, letterSpacing: '0.06em', maxWidth: 560, marginInline: 'auto' }}>
            Doge had its pack. Cate had its litter. FISHE has a reef — and every holder is a scale.
          </p>
        </div>
      </div>
    </section>
  );
}
